import React, { useState, useEffect } from 'react';
import { getActivity } from '../../api/client';

function fmtTime(iso) {
  if (!iso) return '--';
  try {
    return new Date(iso).toLocaleTimeString('en-IN', {
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false, timeZone: 'Asia/Kolkata',
    });
  } catch { return '--'; }
}

function clean(sym) {
  return (sym || '').replace(/^(NSE:|BSE:)/, '');
}

export default function ActivityFeed() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getActivity();
        setEvents(res.data.events || []);
      } catch {}
    };
    fetch();
    const t = setInterval(fetch, 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ fontWeight: 600, marginBottom: 12 }}>Activity Feed</div>

      <div style={{ overflowY: 'auto', flex: 1, minHeight: 0 }}>
        {events.length === 0 ? (
          <div style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center', padding: '32px 0' }}>
            No activity today yet
          </div>
        ) : events.map((ev, i) => {
          const isEntry = ev.type === 'entry';
          const pnlColor = ev.pnl == null
            ? 'var(--muted)'
            : ev.pnl >= 0 ? 'var(--green)' : 'var(--red)';

          return (
            <div key={i} style={{
              display: 'flex', alignItems: 'flex-start', gap: 10,
              padding: '7px 0',
              borderBottom: i < events.length - 1 ? '1px solid var(--border)' : 'none',
            }}>
              {/* Direction indicator */}
              <div style={{
                width: 26, height: 26, borderRadius: '50%', flexShrink: 0, marginTop: 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11,
                background: isEntry
                  ? 'rgba(52,211,153,0.12)' : 'rgba(248,113,113,0.12)',
                color: isEntry ? 'var(--green)' : 'var(--red)',
                border: `1px solid ${isEntry ? 'rgba(52,211,153,0.25)' : 'rgba(248,113,113,0.25)'}`,
                fontWeight: 700,
              }}>
                {isEntry ? '▲' : '▼'}
              </div>

              {/* Main content */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: isEntry ? 'var(--green)' : 'var(--red)' }}>
                    {isEntry ? 'ENTRY' : 'EXIT'}
                  </span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 140 }}>
                    {clean(ev.symbol)}
                  </span>
                  {ev.pnl != null && (
                    <span style={{ fontSize: 12, fontWeight: 700, color: pnlColor, marginLeft: 'auto', whiteSpace: 'nowrap' }}>
                      {ev.pnl >= 0 ? '+' : ''}₹{ev.pnl.toFixed(2)}
                    </span>
                  )}
                </div>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                  {ev.side} {ev.qty} @ ₹{Number(ev.price || 0).toFixed(2)}
                  <span style={{ marginLeft: 5, background: 'var(--surface)', padding: '1px 5px', borderRadius: 3, fontSize: 10 }}>
                    {ev.strategy}
                  </span>
                </div>
              </div>

              {/* Time */}
              <div style={{ fontSize: 10, color: 'var(--muted)', whiteSpace: 'nowrap', flexShrink: 0, marginTop: 2 }}>
                {fmtTime(ev.time)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
